import Server from '../../libs/server'

const apis = {
  examList: [ '/exam/examination/list', 'get' ],
  examInfo: [ '/exam/examination/info', 'get' ],
  createPaper: [ '/exam/paper/create', 'post' ],
  submitAnswers: [ '/exam/paper/submit', 'post' ]
}

export default {
  namespaced: true,

  state: {
    paperId: undefined,
    paper: [],
    answers: null
  },
  mutations: {
    setPaper (state, { paperId, paperContent }) {
      state.paperId = paperId
      state.paper = paperContent
      state.answers = (new Array(paperContent.length)).fill([])
    }
  },
  actions: {
    async fetchExamList () {
      const [ url, method ] = apis.examList
      const { data } = await Server({
        url,
        method,
        loading: true
      })
      return data
    },

    async fetchExamInfo (store, courseId) {
      const [ url, method ] = apis.examInfo
      const { data } = await Server({
        url,
        method,
        data: { courseId }
      })
      return data
    },

    async createPaper (store, courseId) {
      const [ url, method ] = apis.createPaper
      const res = await Server({
        url,
        method,
        ignoreCode: true,
        data: {
          courseId,
          userAgent: navigator.userAgent
        }
      })
      return res
    },

    async submitAnswers ({ state }) {
      const [ url, method ] = apis.submitAnswers
      const { paperId, answers } = state
      const { data } = await Server({
        url,
        method,
        data: { paperId, answers }
      })
      return data
    }
  }
}
